import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MatStepper} from '@angular/material/stepper';

@Injectable({
    providedIn: 'root'
})
export class RmShoppingCartService {
    private show: any;
    private stepper = null;

    constructor() {
        this.show = new BehaviorSubject<boolean>(false);
    }

    setShow(data: boolean) {
        this.show.next(data);
    }

    getShow() {
        return this.show.asObservable();
    }

    setStepper(stepper: MatStepper) {
        this.stepper = stepper;
    }

    getStepper() {
        return this.stepper;
    }
}
